<template>
     <div class="flex flex-row">
        <div class="tabs-details w-9/12">
            <slot></slot>
        </div>

        <div class="ml-8 w-3/12 relative">
            <h3 id="tab-heading" class="text-center border-b border-gray-400">{{ title }}</h3>

            <div role="tablist"
                aria-labelledby="tab-heading"
                aria-orientation="vertical"
                class="flex flex-col sticky top-0 overflow-y-scroll"
            >
                <a v-for="(tab, index) in tabs"
                   class="no-underline font-bold text-xs py-1 px-3 border-b-2 border-white"
                   :class="{ 'text-teal-700 bg-transparent pl-0 text-sm': tab.isActive, 'bg-gray-300 hover:bg-gray-200 text-gray-800': tab.isActive == false }"
                   :href="tab.href" @click="selectTab(tab)"
                   :key="tab.name"
                   :id="tab.name"
                   :ref="'tab-' + index"
                   role="tab"
                   :tabindex="tab.isActive ? '0' : '-1'"
                   :aria-selected="tab.isActive ? 'true' : 'false'"
                   @keyup.down.stop="downArrowPressed"
                   @keyup.up.stop="upArrowPressed"
                >
                    {{ tab.name }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: ''
    },
    data() {
        return {
            tabs: [],
            selectedTabIndex: 0,
        };
    },
    created() {
        this.tabs = this.$children;
    },
    methods: {
        selectTab(selectedTab) {
            this.tabs.forEach((tab, index) => {
                let isSelected = tab.href == selectedTab.href;
                tab.isActive = isSelected;

                if (isSelected) {
                    this.selectedTabIndex = index;
                }
            });
        },
        selectTabByIndex() {
            this.tabs.forEach((tab, index) => {
                let isSelected = index == this.selectedTabIndex;
                tab.isActive = isSelected;
            });

            this.$nextTick(() => {
                this.$refs['tab-' + this.selectedTabIndex][0].focus();
            });
        },
        downArrowPressed(e) {
            e.preventDefault();
            this.selectedTabIndex = Math.min(this.selectedTabIndex + 1, this.tabs.length);
            this.selectTabByIndex();
        },
        upArrowPressed(e) {
            e.preventDefault();
            this.selectedTabIndex = Math.max(this.selectedTabIndex - 1, 0);
            this.selectTabByIndex();
        },
    },
};
</script>
